const MODIFY_FV_RETURN_POSITION_HOOK_NAME = 'modify-fv-return-position';

const DEFAULT_VARIANT = 'OC_ON_TOP_OF_VIEWPORT';

class ModifyFVReturnPosition {
    constructor(box, data, options) {
        this.box = box;
        this.data = data;
        this.feedContainer = box.rbox.parentFeed.origContainer;
        this.config = ModifyFVReturnPosition.getConfig(options);
        this.variantScrollFunction = this.getVariantScrollFunction();
        TRC.customHooks[MODIFY_FV_RETURN_POSITION_HOOK_NAME].didAspect = false;
        TRC.aspect.after(box.rbox, 'openFeedView', () => {
            if (!TRC.customHooks[MODIFY_FV_RETURN_POSITION_HOOK_NAME].didAspect) {
                this.setAspectAfterRemoveIframe();
            }
        }, false);
    }

    static getConfig(options) {
        const variant = ModifyFVReturnPosition.VARIANTS[options.variant] || DEFAULT_VARIANT;
        return {variant};
    }

    setAspectAfterRemoveIframe() {
        TRC.aspect.after(TRC.FeedView, 'removeIframe', () => {
            setTimeout(() => {
                this.variantScrollFunction();
                TRCImpl.sendAbTestEvent(ModifyFVReturnPosition.EVENT_NAME, `variant-${this.config.variant}`);
            }, 0);
        }, false);
    }

    getVariantScrollFunction() {
        switch (this.config.variant) {
            case ModifyFVReturnPosition.VARIANTS.TOP_OF_FEED:
                return () => { this.feedContainer.scrollIntoView(true); };
            case ModifyFVReturnPosition.VARIANTS.OC_ON_BOTTOM_OF_VIEWPORT:
                return () => { this.box.scrollIntoView(false); };
            case ModifyFVReturnPosition.VARIANTS.OC_ON_TOP_OF_VIEWPORT:
                return () => { this.box.scrollIntoView(true); };
            default:
                return () => { this.box.scrollIntoView(false); };
        }
    }

    static disableModifyForItem(box, data) {
        return box.rbox.isFeedCard !== true || data.isSyndicated === 'true';
    }
}

(() => {
    ModifyFVReturnPosition.hooks = {
        'item-renderer': function (box, data) {
            if (ModifyFVReturnPosition.disableModifyForItem(box, data)) { return; }
            const cmm = TRC.CustomModulesManager;
            const options = (cmm && cmm.registeredModules && cmm.registeredModules[MODIFY_FV_RETURN_POSITION_HOOK_NAME].options) || {};
            new ModifyFVReturnPosition(box, data, options);
        }
    };

    ModifyFVReturnPosition.EVENT_NAME = 'feedView-modify-return-position';

    ModifyFVReturnPosition.VARIANTS = {
        TOP_OF_FEED: 'TOP_OF_FEED',
        OC_ON_BOTTOM_OF_VIEWPORT: 'OC_ON_BOTTOM_OF_VIEWPORT',
        OC_ON_TOP_OF_VIEWPORT: 'OC_ON_TOP_OF_VIEWPORT'
    };

    TRC.customHooks[MODIFY_FV_RETURN_POSITION_HOOK_NAME] = ModifyFVReturnPosition;
})();